import { FC, MouseEvent, useCallback } from "react";
import { Button, Stack, Tooltip, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  setAccountSetupDialogType,
  setMissingSubAccountRoleAccountId,
} from "../../../../../../../store/account-setup/accountSetupSlice";
import { useAppDispatch } from "../../../../../../../store/hooks";

interface ProviderAccountNameCellProps {
  id: string;
}

export const MissingSubAccountRoleDescColumn: FC<
  ProviderAccountNameCellProps
> = ({ id }) => {
  const dispatch = useAppDispatch();

  const addRoleClickHandler = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      event.preventDefault();

      dispatch(setAccountSetupDialogType("add-sub-account-role"));
      dispatch(setMissingSubAccountRoleAccountId(id));
    },
    [dispatch, id],
  );
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Stack spacing={0.5} direction="row">
        <WarningAmberIcon color="warning" fontSize="small" />
        <Typography color="warning.main">Missing Role:</Typography>
      </Stack>
      <Typography variant="body2">
        The{" "}
        <Typography component="span" variant="inherit" fontWeight="medium">
          Organization Account Access Role
        </Typography>
        is missing for this account. Please add the
        <Typography component="span" variant="inherit" fontWeight="medium">
          Cloudchipr Role
        </Typography>
        to enable data visibility.
      </Typography>
      <Tooltip
        arrow
        placement="top"
        title="Cloudchipr needs this role to assume access into the sub-account from the management account and securely collect cost, usage, and resource data."
      >
        <InfoOutlinedIcon fontSize="small" />
      </Tooltip>
      <Button
        variant="outlined"
        onClick={addRoleClickHandler}
        size="small"
        sx={{
          ml: 1.5,
        }}
      >
        Add Role
      </Button>
    </Stack>
  );
};
